import { render, staticRenderFns } from "./CrmPanel.vue?vue&type=template&id=1344aae2&scoped=true&"
import script from "./CrmPanel.vue?vue&type=script&lang=js&"
export * from "./CrmPanel.vue?vue&type=script&lang=js&"
import style0 from "./CrmPanel.vue?vue&type=style&index=0&id=1344aae2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1344aae2",
  null
  
)

export default component.exports